/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';

import './index.scss';
import { event } from 'react-ga';

Modal.setAppElement('#root');
const insuranceNameRegex = /^[a-zA-Z0-9\s\-\(\)]*$/;
class InsuranceEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      insurance_name: ''
    };
    this.onNameChange = this.onNameChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.insuranceName !== nextProps.insuranceName) {
      const { insuranceName } = nextProps;
      this.setState({
        insurance_name: insuranceName.selectedValue
      });
    }
  }

  componentDidMount() {
    const { insuranceName } = this.props;
    this.setState({
      insurance_name: insuranceName.selectedValue
    });
  }

  onNameChange(event) {
    if (event.target.value === '' || (insuranceNameRegex.test(event.target.value) && event.target.value.trim() !== '')) {
      this.setState({
        [event.target.name]: event.target.value
      });
    }
  }

  render() {
    const {
      modelopen,
      closeServiceModal,
      insuranceName,
      editSaveHandler
    } = this.props;
    const { insurance_name } = this.state;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={closeServiceModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="pc-modal-header">
              <div className="title">Edit insurance</div>
              <button className="modal-close" onClick={closeServiceModal}>
                <i className="material-icons">close</i>
              </button>
              <div className="uploaded-list">
                <div className="uploaded-list_container">
                  <input value={insurance_name} name="insurance_name" className="uploaded-list_container_name" onChange={this.onNameChange} />
                </div>
              </div>
              <div className="actions">
                <button
                  className="btn btn--primary btn--lg"
                  disabled={insurance_name?.length < 1}
                  onClick={() => editSaveHandler(insurance_name, insuranceName.type, insuranceName.index)}
                >
                  SAVE
                </button>
                <button
                  className="btn btn--secondary btn--lg"
                  onClick={closeServiceModal}
                >
                  CANCEL
                </button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default InsuranceEdit;
